import { useState } from "react";
import {
  ProductCard_1,
  ProductCard_2,
  ProductCard_4,
  ProductCard_5,
  SolutionCard_1,
  SolutionCard_2,
  SolutionCard_3,
  SolutionCard_4,
  SolutionCard_5,
} from "./ServiceDetails";

import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const ProductsCard = () => {
  return (
    <div className="mt-8 md:m-10">
      <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-4">
        <div className="grid items-stretch content-center grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 m-auto">
          {/* eslint-disable react/jsx-pascal-case */}
          <ProductCard_1 />
          <ProductCard_2 />
          <ProductCard_4 />
          <ProductCard_5 />
          {/* eslint-enable react/jsx-pascal-case */}
        </div>
      </div>
    </div>
  );
};

const SolutionsCard = () => {
  return (
    <div className="mt-8 md:m-10">
      <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-4">
        <div className="grid items-stretch content-center grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 m-auto">
          {/* eslint-disable react/jsx-pascal-case */}
          <SolutionCard_1 />
          <SolutionCard_2 />
          <SolutionCard_3 />
          <SolutionCard_4 />
          <SolutionCard_5 />
          {/* eslint-enable react/jsx-pascal-case */}
        </div>
      </div>
    </div>
  );
};

const MainService = () => {
  const [toggle, setToggle] = useState(true);
  const { t } = useLanguage();

  const ClickProduct = () => {
    setToggle(!toggle);
  };

  const toggleDecorationsOn =
    "mt-8 mb-4 mx-2 text-xl md:text-2xl font-bold text-white uppercase bg-blue p-4 rounded-xl border-2 border-blue transition-all duration-300 shadow-lg";
  const toggleDecorationsOff =
    "mt-8 mb-4 mx-2 text-xl md:text-2xl font-bold text-blue uppercase bg-transparent p-4 rounded-xl border-2 border-darkBlue/50 hover:border-darkBlue hover:bg-darkBlue/5 transition-all duration-300";

  return (
    <div className="my-16 md:my-24 px-4">
      <div className="w-full m-auto pb-4 lg:px-0">
        <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-4">
          <p className="text-sm font-semibold uppercase tracking-widest text-orange mb-3">
            {t("home.sectionLabel")}
          </p>

          <div className="flex m-auto justify-start">
            <p className="font-bold text-2xl md:text-3xl lg:text-4xl xl:text-4xl text-blue text-start leading-snug max-w-5xl">
              {t("home.title")}
            </p>
          </div>

          <div className="mt-4 mb-6 h-1 w-20 rounded-full bg-gradient-to-r from-orange to-pink" />

          <div className="m-auto justify-start mt-4 md:mt-8 text-base md:text-lg lg:text-xl text-darkBlue/70 space-y-4 max-w-5xl">
            <p className="text-start leading-relaxed">{t("home.desc1")}</p>
            <p className="text-start leading-relaxed">{t("home.desc2")}</p>
          </div>
        </div>

        <div className=" h-full">
          <div className="flex justify-center m-auto">
            <button
              className={
                toggle ? `${toggleDecorationsOn} ` : `${toggleDecorationsOff} `
              }
              onClick={ClickProduct}
            >
              {t("home.tabProducts")}
            </button>
            <button
              className={
                toggle ? `${toggleDecorationsOff} ` : `${toggleDecorationsOn} `
              }
              onClick={ClickProduct}
            >
              {t("home.tabSolutions")}
            </button>
          </div>
          {toggle ? <ProductsCard /> : <SolutionsCard />}
        </div>
      </div>
      <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-4 mt-12">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/usecase"
            className="w-full sm:w-auto text-center text-white font-bold text-sm md:text-base uppercase border-2 border-orange bg-orange hover:bg-red hover:border-red py-3 px-8 rounded-lg transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
          >
            {t("home.ctaUseCases")}
          </Link>
          <Link
            to="/contact"
            className="w-full sm:w-auto text-center text-orange font-bold text-sm md:text-base uppercase border-2 border-orange hover:bg-orange hover:text-white py-3 px-8 rounded-lg transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
          >
            {t("home.ctaTalk")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MainService;
